const slider = [
  {
    color: "#A0042D",
    image: "/assets/slider/header-1.png",
    title: "ANIME WORLD",
    description:
      "Infos description sur l’exposition/ quelquechose qui donne envie des details, liste des personnes ou bien programme que les gens vont suivre durant cette exposition.",
    date: "19 jan - 18 féb",
    price: "25€*",
    guests: ["Prénom Fameux", "Deuxième Personne", "Peut-être troisieme"],
  },
  {
    color: "#FFD53D",
    image: "/assets/slider/header-2.png",
    title: "EXPO COUP 2022",
    description:
      "Infos description sur l’exposition/ quelquechose qui donne envie des details, liste des personnes ou bien programme que les gens vont suivre durant cette exposition.",
    date: "19 jan - 18 féb",
    price: "25€*",
    guests: ["Prénom Fameux", "Deuxième Personne", "Peut-être troisieme"],
  },
  {
    color: "#040F0F",
    image: "/assets/slider/header-3.png",
    title: "BOLLYWOOD EXPO",
    description:
      "Infos description sur l’exposition/ quelquechose qui donne envie des details, liste des personnes ou bien programme que les gens vont suivre durant cette exposition.",
    date: "19 jan - 18 féb",
    price: "25€*",
    guests: ["Prénom Fameux", "Deuxième Personne", "Peut-être troisieme"],
  },
];

export default slider;
